export default "__VITE_ASSET__CGdZA1Y3__"